export default __webpack_public_path__ + "static/media/linkedinLogo.e14142be.svg";